/* C04 · qt-marquee.js — seamless USP loop. Clones the Liquid-rendered set once (aria-hidden + inert,
   editor ids stripped) and starts the CSS animation. In the theme editor, selecting a USP pauses the
   band so the merchant can see it. Spec: 01-componenten.md C04. */
import { register, prefersReducedMotion } from '@qt/core';

register('.qt-usp-marquee', {
  init(root) {
    const band = root.querySelector('.qt-usp-marquee__band');
    const set = band?.querySelector('.qt-usp-marquee__set');
    if (!set || !set.children.length || prefersReducedMotion()) return; // GR-17: no loop, no copy
    const copy = set.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.inert = true;
    copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach((el) => {
      el.removeAttribute('id');
      el.removeAttribute('data-shopify-editor-block');
    });
    band.append(copy);
    root.classList.add('is-looping');
  },
  destroy(root) {
    root.querySelectorAll('.qt-usp-marquee__set[aria-hidden]').forEach((copy) => copy.remove());
    root.classList.remove('is-looping', 'is-paused');
  },
  select(root) {
    root.classList.add('is-paused');
  },
  deselect(root) {
    root.classList.remove('is-paused');
  },
});
